import { jsx as _jsx } from "react/jsx-runtime";
import BreadcrumbGroup from '@amzn/awsui-components-react-v3/polaris/breadcrumb-group';
export const SBTSBreadcrumbGroup = ({ items, ariaLabel = "Breadcrumbs", onClick }) => {
    return (_jsx(BreadcrumbGroup, { items: items, ariaLabel: ariaLabel, onClick: onClick }));
};
export default SBTSBreadcrumbGroup;
